module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-quote-2.a6d06d8.jpg";